/**
 * BotTab — вкладка «Ассистент» карточки клиента: привязка номера
 * WhatsApp, режим ассистента и проверка бота сообщением «от пациента».
 *
 * Состояние обеих настроек приходит в карточке клиента, поэтому вкладка
 * принимает `detail` целиком: отдельных ручек «прочитать привязку» и
 * «прочитать режим» у бэка нет и не нужно.
 *
 * Карточки пересоздаём по `key` при смене клиники: внутри формы живёт
 * локальный стейт, и без этого в открытой карточке другого клиента
 * остались бы чужие поля.
 */

import type {ClientDetail} from '@services/clients';

import {AiModeCard} from './AiModeCard';
import {SimulateCard} from './SimulateCard';
import {WhatsAppCard} from './WhatsAppCard';

type Props = {clientId: string; detail: ClientDetail; onSaved: (text: string) => void};

export const BotTab = ({clientId, detail, onSaved}: Props) => (
  <div className="flex flex-col gap-3.5">
    <WhatsAppCard
      key={`wa-${clientId}`}
      clientId={clientId}
      binding={detail.whatsapp}
      onSaved={onSaved}
    />
    <AiModeCard
      clientId={clientId}
      mode={detail.aiMode}
      reason={detail.aiModeReason}
      changedAt={detail.aiModeChangedAt}
      onSaved={onSaved}
    />
    <SimulateCard clientId={clientId} />
  </div>
);
